export interface PortalUser {
  id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
}

export interface PortalMeResponse {
  user: PortalUser;
  realm_roles: string[];
  permissions: string[];
}

const IGNORED_REALM_ROLES = new Set([
  'default-roles-riche',
  'offline_access',
  'uma_authorization',
]);

const ADMIN_REALM_ROLES = new Set(['api-admin', 'plugin-admin']);

export const getPortalUserDisplayName = (user: PortalUser) => {
  const fullName = `${user.first_name} ${user.last_name}`.trim();
  return fullName || user.username;
};

export const getPortalUserInitials = (user: PortalUser) => {
  if (user.first_name && user.last_name) {
    return `${user.first_name[0]}${user.last_name[0]}`.toUpperCase();
  }

  if (user.first_name) {
    return user.first_name[0].toUpperCase();
  }

  return user.username[0]?.toUpperCase() ?? '?';
};

export const getPortalUserRoleLabel = (
  realmRoles: string[],
  username: string
) => {
  if (realmRoles.some(role => ADMIN_REALM_ROLES.has(role))) {
    return 'Админ';
  }

  const role = realmRoles.find(item => !IGNORED_REALM_ROLES.has(item));

  if (role) {
    return role.replace(/-/g, ' ');
  }

  return username;
};

export const fetchPortalMe = async (): Promise<PortalMeResponse | null> => {
  try {
    const response = await fetch('/api/portal/me', {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    return (await response.json()) as PortalMeResponse;
  } catch {
    return null;
  }
};
